<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<h2 class="slds-m-top_small slds-m-left_small slds-text-heading_medium">{{cd.label}}</h2>
<h3 *ngIf="cd.subLabel" class="slds-m-left_small slds-text-heading_label">{{cd.subLabel}}</h3>

<div *ngIf="isNoData"
     class="slds-p-top_small slds-m-left_small slds-text-color_weak" i18n>No data (yet)
</div>

<div #chart class="pie-chart"></div>
